import api from '@libs/api'

import { handleServiceError } from '@utils/errors'
import type { IApiData, IVendor, UserType } from '@utils/types'

type ISendContact = {
  firstName: string
  lastName: string
  email: string
  phone: string
  message: string
  type: UserType | 'other'
}

const sendContact = async (
  data: ISendContact
): Promise<IApiData<IVendor[]>> => {
  try {
    const response = await api.post({
      path: '/contact',
      authenticate: false,
      data,
    })

    return response
  } catch (err: any) {
    throw handleServiceError(err)
  }
}

export default {
  sendContact,
}
